export function getView(is_new_tasks_enabled) {
  return is_new_tasks_enabled ? 'New' : 'Old'
}
